import React from 'react';
export const ABTestContext = React.createContext<Record<string, string>>({});
